import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import {
  Buttons,
  Spacer,
  boxContainer,
  questionnaireComponents,
  inputFields,
} from "../../components";

import "./styles.css";

const Academics = ({ setPage }) => {
  const questionnaire = useSelector(
    (state) => state?.students?.student?.profileBuilder
  );

  const [state, setState] = useState({
    uniRankingImportance: null,
    uniType: null,
    uniRankingInCoursesImportance: null,
    knowMajor: null,
    majorsInterested: [],
    courseDurationPreference: null,
  });

  useEffect(() => {
    setState({
      uniRankingImportance: questionnaire?.uniRankingImportance ?? null,
      uniType: questionnaire?.uniType ?? null,
      uniRankingInCoursesImportance:
        questionnaire?.uniRankingInCoursesImportance ?? null,
      knowMajor: questionnaire?.knowMajor ?? null,
      majorsInterested: questionnaire?.majorsInterested ?? [],
      courseDurationPreference: questionnaire?.courseDurationPreference ?? null,
    });
  }, [questionnaire]);

  return (
    <boxContainer.LiteBoxContainer>
      <div className="font-bold flex justify-between">
        <questionnaireComponents.QuestionnaireLabel
          text="1. How important is the overall ranking of the university?"
          required
        />
        <span className="text-[0.75em] text-grayText opacity-60">
          (least important 1, important 3, most important 5)
        </span>
      </div>
      <Spacer height="0.625em" />
      <questionnaireComponents.QuestionnaireCircleInput
        value={state?.uniRankingImportance}
      />
      <Spacer height="1.5em" />

      <questionnaireComponents.QuestionnaireLabel
        text="2. Which type of university would you prefer?"
        required
      />
      <Spacer height="0.625em" />
      <div className="pl-3">
        <inputFields.HorizontalRadio
          value={state.uniType}
          items={[
            { label: "Private", value: "private" },
            { label: "Public", value: "public" },
            { label: "No Preference", value: "no_pref" },
          ]}
        />
      </div>

      <Spacer height="1.5em" />
      <questionnaireComponents.QuestionnaireLabel
        text="3. How important is the university's ranking in the courses/majors of
          your choice?"
        required
      />
      <Spacer height="0.625em" />
      <questionnaireComponents.QuestionnaireCircleInput
        value={state?.uniRankingInCoursesImportance}
      />
      <Spacer height="1.5em" />

      <questionnaireComponents.QuestionnaireLabel
        text="4. Do you know what course or major you would like to study?"
        required
      />
      <Spacer height="0.625em" />
      <div className="pl-3">
        <inputFields.HorizontalRadio
          value={state.knowMajor}
          items={[
            { label: "Yes", value: "yes" },
            { label: "No", value: "no" },
          ]}
        />
      </div>

      <Spacer height="1.5em" />

      <questionnaireComponents.QuestionnaireLabel text="5. Which course(s)/majors(s) are you interested in?" />
      <Spacer height="0.3125em" />
      <div className="w-[31.25em] pl-3">
        <questionnaireComponents.QuestionnaireValueBox
          value={state?.majorsInterested?.map((item, index) => (
            <span
              className="p-2 bg-liteBoxBg border border-liteBoxBorder mr-2 rounded-lg"
              key={index}
            >
              {item}
            </span>
          ))}
        />
      </div>
      <Spacer height="1.5em" />

      <questionnaireComponents.QuestionnaireLabel
        text={
          <div>
            6. What is your preferred course duration?
            <span className="text-[0.75em] text-grayText opacity-60 ml-5">
              {"(5 -> 5+)"}
            </span>
          </div>
        }
      />
      <Spacer height="0.625em" />
      <questionnaireComponents.QuestionnaireCircleInput
        courseduration
        value={state?.courseDurationPreference}
      />
      <Spacer height="1.25em" />
      <div className="flex justify-end">
        <div className="w-[12.5em]">
          <Buttons.DefaultButton
            size="large"
            width="full"
            onClick={() => setPage("Location")}
          >
            Next
          </Buttons.DefaultButton>
        </div>
      </div>
    </boxContainer.LiteBoxContainer>
  );
};

export default Academics;
